// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"1OC2a":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IconContext", ()=>IconContext);
parcelHelpers.export(exports, "IllustrationContext", ()=>IllustrationContext);
parcelHelpers.export(exports, "createIcon", ()=>createIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _skeleton = require("./Skeleton");
var _useSpectrumContextProps = require("./useSpectrumContextProps");
const IconContext = /*#__PURE__*/ (0, _react.createContext)({});
const IllustrationContext = /*#__PURE__*/ (0, _react.createContext)({});
function createIcon(Component, context = IconContext) {
    return (props)=>{
        let ref = (0, _react.useRef)(null);
        let ctx;
        // TODO: remove this default once we release RAC and use DEFAULT_SLOT.
        [ctx, ref] = (0, _useSpectrumContextProps.useSpectrumContextProps)({
            slot: props.slot || 'icon'
        }, ref, context);
        let { render, styles } = ctx;
        let { UNSAFE_className, UNSAFE_style, slot, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, ...otherProps } = props;
        if (!ariaHidden) ariaHidden = undefined;
        let svg = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _skeleton.SkeletonWrapper), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
                ...otherProps,
                focusable: false,
                "aria-label": ariaLabel,
                "aria-hidden": ariaLabel ? ariaHidden || undefined : true,
                role: "img",
                "data-slot": slot,
                className: (UNSAFE_className ?? '') + ' ' + (0, _skeleton.useSkeletonIcon)(styles),
                style: UNSAFE_style
            })
        });
        if (render) return render(svg);
        return svg;
    };
}
try {
    // @ts-ignore
    IconContext.displayName = "IconContext";
    // @ts-ignore
    IconContext.__docgenInfo = {
        "description": "",
        "displayName": "IconContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<IconContextValue, SVGElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Icon.tsx#IconContext"] = {
        docgenInfo: IconContext.__docgenInfo,
        name: "IconContext",
        path: "packages/@react-spectrum/s2/src/Icon.tsx#IconContext"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    IllustrationContext.displayName = "IllustrationContext";
    // @ts-ignore
    IllustrationContext.__docgenInfo = {
        "description": "",
        "displayName": "IllustrationContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "ContextValue<IllustrationContextValue, SVGElement>"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Icon.tsx#IllustrationContext"] = {
        docgenInfo: IllustrationContext.__docgenInfo,
        name: "IllustrationContext",
        path: "packages/@react-spectrum/s2/src/Icon.tsx#IllustrationContext"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"react/jsx-runtime":"2JzhG","react":"jEiK2","./Skeleton":"2hWWB","./useSpectrumContextProps":"ileU6","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"2hWWB":[function(require,module,exports) {
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLoadingAnimation", ()=>useLoadingAnimation);
parcelHelpers.export(exports, "SkeletonContext", ()=>SkeletonContext);
parcelHelpers.export(exports, "useIsSkeleton", ()=>useIsSkeleton);
/**
 * A Skeleton wraps around content to render it as a placeholder.
 */ parcelHelpers.export(exports, "Skeleton", ()=>Skeleton);
parcelHelpers.export(exports, "loadingStyle", ()=>loadingStyle);
parcelHelpers.export(exports, "useSkeletonText", ()=>useSkeletonText);
// Rendered inside <Text> to create skeleton line boxes via box-decoration-break.
parcelHelpers.export(exports, "SkeletonText", ()=>SkeletonText);
// Clones the child element and displays it with skeleton styling.
parcelHelpers.export(exports, "SkeletonWrapper", ()=>SkeletonWrapper);
// Adds default border radius around icons when displayed in a skeleton.
parcelHelpers.export(exports, "useSkeletonIcon", ()=>useSkeletonIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _utils = require("@react-aria/utils");
var _runtime = require("../style/runtime");
let reduceMotion = typeof window?.matchMedia === 'function' ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
function useLoadingAnimation(isAnimating) {
    let animationRef = (0, _react.useRef)(null);
    return (0, _react.useCallback)((element)=>{
        if (isAnimating && !animationRef.current && element && !reduceMotion) {
            // Use web animation API instead of CSS animations so that we can
            // synchronize it between all loading elements on the page (via startTime).
            animationRef.current = element.animate([
                {
                    backgroundPosition: '100%'
                },
                {
                    backgroundPosition: '0%'
                }
            ], {
                duration: 2000,
                iterations: Infinity,
                easing: 'ease-in-out'
            });
            animationRef.current.startTime = 0;
        } else if (!isAnimating && animationRef.current) {
            animationRef.current.cancel();
            animationRef.current = null;
        }
    }, [
        isAnimating
    ]);
}
const SkeletonContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useIsSkeleton() {
    return (0, _react.useContext)(SkeletonContext) || false;
}
function Skeleton({ children, isLoading }) {
    // Disable all form components inside a skeleton.
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonContext.Provider, {
        value: isLoading,
        children: children
    });
}
const loadingStyle = "-my2ngj";
function useSkeletonText(children, style) {
    let isSkeleton = (0, _react.useContext)(SkeletonContext);
    if (isSkeleton) {
        children = /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonText, {
            children: children
        });
        style = {
            ...style,
            // This ensures the ellipsis on truncated text is also hidden.
            // -webkit-text-fill-color overrides any `color` property that is also set.
            WebkitTextFillColor: 'transparent'
        };
    }
    return [
        children,
        style
    ];
}
function SkeletonText({ children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        // @ts-ignore - compatibility with React < 19
        inert: "true",
        ref: useLoadingAnimation(true),
        className: loadingStyle + " . aa _sb _vb _wb _xb _yb",
        children: children
    });
}
function SkeletonWrapper({ children }) {
    let isLoading = (0, _react.useContext)(SkeletonContext);
    let animation = useLoadingAnimation(isLoading || false);
    if (isLoading == null) return children;
    let childRef = 'ref' in children ? children.ref : children.props.ref;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SkeletonContext.Provider, {
        value: null,
        children: isLoading ? /*#__PURE__*/ (0, _react.cloneElement)(children, {
            ref: (0, _utils.mergeRefs)(childRef, animation),
            className: (children.props.className || '') + ' ' + loadingStyle,
            inert: 'true'
        }) : children
    });
}
function useSkeletonIcon(styles) {
    let isSkeleton = (0, _react.useContext)(SkeletonContext);
    if (isSkeleton) return (0, _runtime.mergeStyles)(" . _vb _wb _xb _yb", styles);
    return styles || '';
}
try {
    // @ts-ignore
    useLoadingAnimation.displayName = "useLoadingAnimation";
    // @ts-ignore
    useLoadingAnimation.__docgenInfo = {
        "description": "",
        "displayName": "useLoadingAnimation",
        "props": {
            "valueOf": {
                "defaultValue": null,
                "description": "Returns the primitive value of the specified object.",
                "name": "valueOf",
                "required": false,
                "type": {
                    "name": "() => boolean"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Skeleton.tsx#useLoadingAnimation"] = {
        docgenInfo: useLoadingAnimation.__docgenInfo,
        name: "useLoadingAnimation",
        path: "packages/@react-spectrum/s2/src/Skeleton.tsx#useLoadingAnimation"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    Skeleton.displayName = "Skeleton";
    // @ts-ignore
    Skeleton.__docgenInfo = {
        "description": "A Skeleton wraps around content to render it as a placeholder.",
        "displayName": "Skeleton",
        "props": {
            "isLoading": {
                "defaultValue": null,
                "description": "",
                "name": "isLoading",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Skeleton.tsx#Skeleton"] = {
        docgenInfo: Skeleton.__docgenInfo,
        name: "Skeleton",
        path: "packages/@react-spectrum/s2/src/Skeleton.tsx#Skeleton"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    SkeletonText.displayName = "SkeletonText";
    // @ts-ignore
    SkeletonText.__docgenInfo = {
        "description": "",
        "displayName": "SkeletonText",
        "props": {}
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Skeleton.tsx#SkeletonText"] = {
        docgenInfo: SkeletonText.__docgenInfo,
        name: "SkeletonText",
        path: "packages/@react-spectrum/s2/src/Skeleton.tsx#SkeletonText"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    SkeletonWrapper.displayName = "SkeletonWrapper";
    // @ts-ignore
    SkeletonWrapper.__docgenInfo = {
        "description": "",
        "displayName": "SkeletonWrapper",
        "props": {}
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Skeleton.tsx#SkeletonWrapper"] = {
        docgenInfo: SkeletonWrapper.__docgenInfo,
        name: "SkeletonWrapper",
        path: "packages/@react-spectrum/s2/src/Skeleton.tsx#SkeletonWrapper"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    useSkeletonIcon.displayName = "useSkeletonIcon";
    // @ts-ignore
    useSkeletonIcon.__docgenInfo = {
        "description": "",
        "displayName": "useSkeletonIcon",
        "props": {
            "properties": {
                "defaultValue": null,
                "description": "",
                "name": "properties",
                "required": true,
                "type": {
                    "name": "string"
                }
            },
            "__@iterator@104": {
                "defaultValue": null,
                "description": "Iterator",
                "name": "__@iterator@104",
                "required": true,
                "type": {
                    "name": "() => IterableIterator<string>"
                }
            },
            "anchor": {
                "defaultValue": null,
                "description": "Returns an `<a>` HTML anchor element and sets the name attribute to the text value\n@deprecated A legacy feature for browser compatibility\n@param name",
                "name": "anchor",
                "required": true,
                "type": {
                    "name": "(name: string) => string"
                }
            },
            "at": {
                "defaultValue": null,
                "description": "Returns a new String consisting of the single UTF-16 code unit located at the specified index.\n@param index The zero-based index of the desired code unit. A negative index will count back from the last item.",
                "name": "at",
                "required": true,
                "type": {
                    "name": "(index: number) => string"
                }
            },
            "big": {
                "defaultValue": null,
                "description": "Returns a `<big>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "big",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "blink": {
                "defaultValue": null,
                "description": "Returns a `<blink>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "blink",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "bold": {
                "defaultValue": null,
                "description": "Returns a `<b>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "bold",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "charAt": {
                "defaultValue": null,
                "description": "Returns the character at the specified index.\n@param pos The zero-based index of the desired character.",
                "name": "charAt",
                "required": true,
                "type": {
                    "name": "(pos: number) => string"
                }
            },
            "charCodeAt": {
                "defaultValue": null,
                "description": "Returns the Unicode value of the character at the specified location.\n@param index The zero-based index of the desired character. If there is no character at the specified index, NaN is returned.",
                "name": "charCodeAt",
                "required": true,
                "type": {
                    "name": "(index: number) => number"
                }
            },
            "codePointAt": {
                "defaultValue": null,
                "description": "Returns a nonnegative integer Number less than 1114112 (0x110000) that is the code point\nvalue of the UTF-16 encoded code point starting at the string element at position pos in\nthe String resulting from converting this object to a String.\nIf there is no element at that position, the result is undefined.\nIf a valid UTF-16 surrogate pair does not begin at pos, the result is the code unit at pos.",
                "name": "codePointAt",
                "required": true,
                "type": {
                    "name": "(pos: number) => number"
                }
            },
            "concat": {
                "defaultValue": null,
                "description": "Returns a string that contains the concatenation of two or more strings.\n@param strings The strings to append to the end of the string.",
                "name": "concat",
                "required": true,
                "type": {
                    "name": "(...strings: string[]) => string"
                }
            },
            "endsWith": {
                "defaultValue": null,
                "description": "Returns true if the sequence of elements of searchString converted to a String is the\nsame as the corresponding elements of this object (converted to a String) starting at\nendPosition \u2013 length(this). Otherwise returns false.",
                "name": "endsWith",
                "required": true,
                "type": {
                    "name": "(searchString: string, endPosition?: number) => boolean"
                }
            },
            "fixed": {
                "defaultValue": null,
                "description": "Returns a `<tt>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "fixed",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "fontcolor": {
                "defaultValue": null,
                "description": "Returns a `<font>` HTML element and sets the color attribute value\n@deprecated A legacy feature for browser compatibility",
                "name": "fontcolor",
                "required": true,
                "type": {
                    "name": "(color: string) => string"
                }
            },
            "fontsize": {
                "defaultValue": null,
                "description": "Returns a `<font>` HTML element and sets the size attribute value\n@deprecated A legacy feature for browser compatibility\n@deprecated A legacy feature for browser compatibility",
                "name": "fontsize",
                "required": true,
                "type": {
                    "name": "{ (size: number): string; (size: string): string; }"
                }
            },
            "includes": {
                "defaultValue": null,
                "description": "Returns true if searchString appears as a substring of the result of converting this\nobject to a String, at one or more positions that are\ngreater than or equal to position; otherwise, returns false.\n@param searchString search string\n@param position If position is undefined, 0 is assumed, so as to search all of the String.",
                "name": "includes",
                "required": true,
                "type": {
                    "name": "(searchString: string, position?: number) => boolean"
                }
            },
            "indexOf": {
                "defaultValue": null,
                "description": "Returns the position of the first occurrence of a substring.\n@param searchString The substring to search for in the string\n@param position The index at which to begin searching the String object. If omitted, search starts at the beginning of the string.",
                "name": "indexOf",
                "required": true,
                "type": {
                    "name": "(searchString: string, position?: number) => number"
                }
            },
            "isWellFormed": {
                "defaultValue": null,
                "description": "Returns true if all leading surrogates and trailing surrogates appear paired and in order.",
                "name": "isWellFormed",
                "required": true,
                "type": {
                    "name": "() => boolean"
                }
            },
            "italics": {
                "defaultValue": null,
                "description": "Returns an `<i>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "italics",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "lastIndexOf": {
                "defaultValue": null,
                "description": "Returns the last occurrence of a substring in the string.\n@param searchString The substring to search for.\n@param position The index at which to begin searching. If omitted, the search begins at the end of the string.",
                "name": "lastIndexOf",
                "required": true,
                "type": {
                    "name": "(searchString: string, position?: number) => number"
                }
            },
            "length": {
                "defaultValue": null,
                "description": "Returns the length of a String object.",
                "name": "length",
                "required": true,
                "type": {
                    "name": "number"
                }
            },
            "link": {
                "defaultValue": null,
                "description": "Returns an `<a>` HTML element and sets the href attribute value\n@deprecated A legacy feature for browser compatibility",
                "name": "link",
                "required": true,
                "type": {
                    "name": "(url: string) => string"
                }
            },
            "localeCompare": {
                "defaultValue": null,
                "description": "Determines whether two strings are equivalent in the current locale.\nDetermines whether two strings are equivalent in the current or specified locale.\n@param that String to compare to target string\n@param that String to compare to target string\n@param locales A locale string or array of locale strings that contain one or more language or locale tags. If you include more than one locale string, list them in descending order of priority so that the first entry is the preferred locale. If you omit this parameter, the default locale of the JavaScript runtime is used. This parameter must conform to BCP 47 standards; see the Intl.Collator object for details.\n@param options An object that contains one or more properties that specify comparison options. see the Intl.Collator object for details.\n@param that String to compare to target string\n@param locales A locale string or array of locale strings that contain one or more language or locale tags. If you include more than one locale string, list them in descending order of priority so that the first entry is the preferred locale. If you omit this parameter, the default locale of the JavaScript runtime is used. This parameter must conform to BCP 47 standards; see the Intl.Collator object for details.\n@param options An object that contains one or more properties that specify comparison options. see the Intl.Collator object for details.",
                "name": "localeCompare",
                "required": true,
                "type": {
                    "name": "{ (that: string): number; (that: string, locales?: string | string[], options?: CollatorOptions): number; (that: string, locales?: LocalesArgument, options?: CollatorOptions): number; }"
                }
            },
            "match": {
                "defaultValue": null,
                "description": "Matches a string with a regular expression, and returns an array containing the results of that search.\nMatches a string or an object that supports being matched against, and returns an array\ncontaining the results of that search, or null if no matches are found.\n@param regexp A variable name or string literal containing the regular expression pattern and flags.\n@param matcher An object that supports being matched against.",
                "name": "match",
                "required": true,
                "type": {
                    "name": "{ (regexp: string | RegExp): RegExpMatchArray; (matcher: { [Symbol.match](string: string): RegExpMatchArray; }): RegExpMatchArray; }"
                }
            },
            "matchAll": {
                "defaultValue": null,
                "description": "Matches a string with a regular expression, and returns an iterable of matches\ncontaining the results of that search.\n@param regexp A variable name or string literal containing the regular expression pattern and flags.",
                "name": "matchAll",
                "required": true,
                "type": {
                    "name": "(regexp: RegExp) => IterableIterator<RegExpExecArray>"
                }
            },
            "normalize": {
                "defaultValue": null,
                "description": "Returns the String value result of normalizing the string into the normalization form\nnamed by form as specified in Unicode Standard Annex #15, Unicode Normalization Forms.\n@param form Applicable values: \"NFC\", \"NFD\", \"NFKC\", or \"NFKD\", If not specified default\nis \"NFC\"\n@param form Applicable values: \"NFC\", \"NFD\", \"NFKC\", or \"NFKD\", If not specified default\nis \"NFC\"",
                "name": "normalize",
                "required": true,
                "type": {
                    "name": "{ (form: \"NFC\" | \"NFD\" | \"NFKC\" | \"NFKD\"): string; (form?: string): string; }"
                }
            },
            "padEnd": {
                "defaultValue": null,
                "description": "Pads the current string with a given string (possibly repeated) so that the resulting string reaches a given length.\nThe padding is applied from the end (right) of the current string.\n@param maxLength The length of the resulting string once the current string has been padded.\nIf this parameter is smaller than the current string's length, the current string will be returned as it is.\n@param fillString The string to pad the current string with.\nIf this string is too long, it will be truncated and the left-most part will be applied.\nThe default value for this parameter is \" \" (U+0020).",
                "name": "padEnd",
                "required": true,
                "type": {
                    "name": "(maxLength: number, fillString?: string) => string"
                }
            },
            "padStart": {
                "defaultValue": null,
                "description": "Pads the current string with a given string (possibly repeated) so that the resulting string reaches a given length.\nThe padding is applied from the start (left) of the current string.\n@param maxLength The length of the resulting string once the current string has been padded.\nIf this parameter is smaller than the current string's length, the current string will be returned as it is.\n@param fillString The string to pad the current string with.\nIf this string is too long, it will be truncated and the left-most part will be applied.\nThe default value for this parameter is \" \" (U+0020).",
                "name": "padStart",
                "required": true,
                "type": {
                    "name": "(maxLength: number, fillString?: string) => string"
                }
            },
            "repeat": {
                "defaultValue": null,
                "description": "Returns a String value that is made from count copies appended together. If count is 0,\nthe empty string is returned.\n@param count number of copies to append",
                "name": "repeat",
                "required": true,
                "type": {
                    "name": "(count: number) => string"
                }
            },
            "replace": {
                "defaultValue": null,
                "description": "Replaces text in a string, using a regular expression or search string.\nPasses a string and {@linkcode replaceValue} to the `[Symbol.replace]` method on {@linkcode searchValue}. This method is expected to implement its own replacement algorithm.\nReplaces text in a string, using an object that supports replacement within a string.\n@param searchValue A string or regular expression to search for.\n@param replaceValue A string containing the text to replace. When the {@linkcode searchValue } is a `RegExp`, all matches are replaced if the `g` flag is set (or only those matches at the beginning, if the `y` flag is also present). Otherwise, only the first match of {@linkcode searchValue } is replaced.\n@param searchValue A string to search for.\n@param replacer A function that returns the replacement text.\n@param searchValue An object that supports searching for and replacing matches within a string.\n@param replaceValue The replacement text.\n@param searchValue A object can search for and replace matches within a string.\n@param replacer A function that returns the replacement text.",
                "name": "replace",
                "required": true,
                "type": {
                    "name": "{ (searchValue: string | RegExp, replaceValue: string): string; (searchValue: string | RegExp, replacer: (substring: string, ...args: any[]) => string): string; (searchValue: { ...; }, replaceValue: string): string; (searchValue: { ...; }, replacer: (substring: string, ...args: any[]) => string): string; }"
                }
            },
            "replaceAll": {
                "defaultValue": null,
                "description": "Replace all instances of a substring in a string, using a regular expression or search string.\n@param searchValue A string to search for.\n@param replaceValue A string containing the text to replace for every successful match of searchValue in this string.\n@param searchValue A string to search for.\n@param replacer A function that returns the replacement text.",
                "name": "replaceAll",
                "required": true,
                "type": {
                    "name": "{ (searchValue: string | RegExp, replaceValue: string): string; (searchValue: string | RegExp, replacer: (substring: string, ...args: any[]) => string): string; }"
                }
            },
            "search": {
                "defaultValue": null,
                "description": "Finds the first substring match in a regular expression search.\n@param regexp The regular expression pattern and applicable flags.\n@param searcher An object which supports searching within a string.",
                "name": "search",
                "required": true,
                "type": {
                    "name": "{ (regexp: string | RegExp): number; (searcher: { [Symbol.search](string: string): number; }): number; }"
                }
            },
            "slice": {
                "defaultValue": null,
                "description": "Returns a section of a string.\n@param start The index to the beginning of the specified portion of stringObj.\n@param end The index to the end of the specified portion of stringObj. The substring includes the characters up to, but not including, the character indicated by end.\nIf this value is not specified, the substring continues to the end of stringObj.",
                "name": "slice",
                "required": true,
                "type": {
                    "name": "(start?: number, end?: number) => string"
                }
            },
            "small": {
                "defaultValue": null,
                "description": "Returns a `<small>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "small",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "split": {
                "defaultValue": null,
                "description": "Split a string into substrings using the specified separator and return them as an array.\n@param separator A string that identifies character or characters to use in separating the string. If omitted, a single-element array containing the entire string is returned.\n@param limit A value used to limit the number of elements returned in the array.\n@param splitter An object that can split a string.\n@param limit A value used to limit the number of elements returned in the array.",
                "name": "split",
                "required": true,
                "type": {
                    "name": "{ (separator: string | RegExp, limit?: number): string[]; (splitter: { [Symbol.split](string: string, limit?: number): string[]; }, limit?: number): string[]; }"
                }
            },
            "startsWith": {
                "defaultValue": null,
                "description": "Returns true if the sequence of elements of searchString converted to a String is the\nsame as the corresponding elements of this object (converted to a String) starting at\nposition. Otherwise returns false.",
                "name": "startsWith",
                "required": true,
                "type": {
                    "name": "(searchString: string, position?: number) => boolean"
                }
            },
            "strike": {
                "defaultValue": null,
                "description": "Returns a `<strike>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "strike",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "sub": {
                "defaultValue": null,
                "description": "Returns a `<sub>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "sub",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "substr": {
                "defaultValue": null,
                "description": "Gets a substring beginning at the specified location and having the specified length.\n@deprecated A legacy feature for browser compatibility\n@param from The starting position of the desired substring. The index of the first character in the string is zero.\n@param length The number of characters to include in the returned substring.",
                "name": "substr",
                "required": true,
                "type": {
                    "name": "(from: number, length?: number) => string"
                }
            },
            "substring": {
                "defaultValue": null,
                "description": "Returns the substring at the specified location within a String object.\n@param start The zero-based index number indicating the beginning of the substring.\n@param end Zero-based index number indicating the end of the substring. The substring includes the characters up to, but not including, the character indicated by end.\nIf end is omitted, the characters from start through the end of the original string are returned.",
                "name": "substring",
                "required": true,
                "type": {
                    "name": "(start: number, end?: number) => string"
                }
            },
            "sup": {
                "defaultValue": null,
                "description": "Returns a `<sup>` HTML element\n@deprecated A legacy feature for browser compatibility",
                "name": "sup",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "toLocaleLowerCase": {
                "defaultValue": null,
                "description": "Converts all alphabetic characters to lowercase, taking into account the host environment's current locale.",
                "name": "toLocaleLowerCase",
                "required": true,
                "type": {
                    "name": "{ (locales?: string | string[]): string; (locales?: LocalesArgument): string; }"
                }
            },
            "toLocaleUpperCase": {
                "defaultValue": null,
                "description": "Returns a string where all alphabetic characters have been converted to uppercase, taking into account the host environment's current locale.",
                "name": "toLocaleUpperCase",
                "required": true,
                "type": {
                    "name": "{ (locales?: string | string[]): string; (locales?: LocalesArgument): string; }"
                }
            },
            "toLowerCase": {
                "defaultValue": null,
                "description": "Converts all the alphabetic characters in a string to lowercase.",
                "name": "toLowerCase",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "toUpperCase": {
                "defaultValue": null,
                "description": "Converts all the alphabetic characters in a string to uppercase.",
                "name": "toUpperCase",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "toWellFormed": {
                "defaultValue": null,
                "description": "Returns a string where all lone or out-of-order surrogates have been replaced by the Unicode replacement character (U+FFFD).",
                "name": "toWellFormed",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "trim": {
                "defaultValue": null,
                "description": "Removes the leading and trailing white space and line terminator characters from a string.",
                "name": "trim",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "trimEnd": {
                "defaultValue": null,
                "description": "Removes the trailing white space and line terminator characters from a string.",
                "name": "trimEnd",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "trimLeft": {
                "defaultValue": null,
                "description": "Removes the leading white space and line terminator characters from a string.\n@deprecated A legacy feature for browser compatibility. Use `trimStart` instead",
                "name": "trimLeft",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "trimRight": {
                "defaultValue": null,
                "description": "Removes the trailing white space and line terminator characters from a string.\n@deprecated A legacy feature for browser compatibility. Use `trimEnd` instead",
                "name": "trimRight",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "trimStart": {
                "defaultValue": null,
                "description": "Removes the leading white space and line terminator characters from a string.",
                "name": "trimStart",
                "required": true,
                "type": {
                    "name": "() => string"
                }
            },
            "toString": {
                "defaultValue": null,
                "description": "Returns a string representation of a string.",
                "name": "toString",
                "required": false,
                "type": {
                    "name": "() => string"
                }
            },
            "valueOf": {
                "defaultValue": null,
                "description": "Returns the primitive value of the specified object.",
                "name": "valueOf",
                "required": false,
                "type": {
                    "name": "() => string"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Skeleton.tsx#useSkeletonIcon"] = {
        docgenInfo: useSkeletonIcon.__docgenInfo,
        name: "useSkeletonIcon",
        path: "packages/@react-spectrum/s2/src/Skeleton.tsx#useSkeletonIcon"
    };
} catch (__react_docgen_typescript_loader_error) {}
try {
    // @ts-ignore
    SkeletonContext.displayName = "SkeletonContext";
    // @ts-ignore
    SkeletonContext.__docgenInfo = {
        "description": "",
        "displayName": "SkeletonContext",
        "props": {
            "value": {
                "defaultValue": null,
                "description": "",
                "name": "value",
                "required": true,
                "type": {
                    "name": "boolean"
                }
            }
        }
    };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["packages/@react-spectrum/s2/src/Skeleton.tsx#SkeletonContext"] = {
        docgenInfo: SkeletonContext.__docgenInfo,
        name: "SkeletonContext",
        path: "packages/@react-spectrum/s2/src/Skeleton.tsx#SkeletonContext"
    };
} catch (__react_docgen_typescript_loader_error) {}

},{"0":"kNryF","1":"kWtWN","2":"6YBwW","react/jsx-runtime":"2JzhG","react":"jEiK2","@react-aria/utils":"e9Yvo","../style/runtime":"dzhKB","@parcel/transformer-js/src/esmodule-helpers.js":"diccK"}],"kNryF":[function() {},{}],"kWtWN":[function() {},{}],"6YBwW":[function() {},{}]},[], null, "parcelRequire94c2")

//# sourceMappingURL=Illustrations.e5d8064a.js.map
